import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "pt-2",
  style: {"width":"100%"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_v_checkbox_btn = _resolveComponent("v-checkbox-btn")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_virtual_scroll = _resolveComponent("v-virtual-scroll")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_btn, {
      size: "small",
      elevation: "0",
      class: "mx-1",
      rounded: "",
      color: "ternary",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openDialog()))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_icon, {
          size: "large",
          left: "",
          class: "pr-2"
        }, {
          default: _withCtx(() => _cache[3] || (_cache[3] = [
            _createTextVNode("$fa-plus")
          ])),
          _: 1
        }),
        _cache[4] || (_cache[4] = _createTextVNode(" une activité "))
      ]),
      _: 1
    }),
    _createVNode(_component_oss_dialog, {
      modelValue: _ctx.dialog,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.dialog) = $event)),
      title: "Ajouter une activité",
      onValid: _ctx.closeDialog,
      width: "40vw"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_v_text_field_filled, {
            label: "Rechercher",
            modelValue: _ctx.searchActivity,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchActivity) = $event)),
            outlined: "",
            density: "compact",
            class: "mb-3"
          }, null, 8, ["modelValue"]),
          _createVNode(_component_v_virtual_scroll, {
            benched: 20,
            items: _ctx.filteredActivitiesList,
            height: "500",
            "item-height": "64"
          }, {
            default: _withCtx(({ item }) => [
              (_openBlock(), _createBlock(_component_v_list_item, {
                key: item.id,
                class: "d-flex align-center mb-1",
                border: "sm",
                variant: "outlined",
                rounded: "xl",
                density: "comfortable",
                style: {"height":"60px"}
              }, {
                prepend: _withCtx(() => [
                  _createVNode(_component_v_checkbox_btn, {
                    density: "comfortable",
                    "model-value": _ctx.isSelectedActivities(item.id),
                    "onUpdate:modelValue": ($event: any) => (_ctx.selectActivities(item)),
                    color: "primary",
                    class: "pr-3 pa-0"
                  }, null, 8, ["model-value", "onUpdate:modelValue"])
                ]),
                default: _withCtx(() => [
                  _createTextVNode(" " + _toDisplayString(item.name) + " - " + _toDisplayString(item.description), 1)
                ]),
                _: 2
              }, 1024))
            ]),
            _: 1
          }, 8, ["items"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "onValid"])
  ]))
}